// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LeftMenu":"ir_a bhp_tr","LeftMenu__link":"ir_b bhp_vt bhp_a bhp_rc","LeftMenu__link__icon":"ir_c"};